module.exports = __webpack_public_path__ + "media/images/redesign-images/backgrounds/bg-paint-7f2205ca36ee71735dd1e1bf73ea2b16.svg";